import React from 'react';

export const INVOICE_STATUS_TOOLTIP = () => (
    <div>
        <p>If &quot;Auto-update&quot; is switched on and the invoice status indicates &quot;- Undefined -&quot;,
            it means that some reporting information is missing to determine automatically the invoice status of the
            distribution.</p>
    </div>
);

export const AUTO_UPDATE_TOOLTIP = () => (
    <div>
        <p>Switch on if you want the invoice status to be updated automatically based on the reports
            and the SLA of the product.</p>
    </div>
);

export const INHERIT_ON_BOOKINGS_TOOLTIP = () => (
    <div>
        <p>Switch on if you want the bookings of the distribution to have their invoice status
            inherited from the invoice status of the distribution (applies only to the bookings which have the option
            &quot;Auto-update invoice status&quot;).</p>
    </div>
);
